import { BasePicker } from 'views/components';
import { configActions } from 'core/Config';
import i18n from 'i18nextInstance';
import { officeActions } from 'core/Office';
import { optionActions } from 'core/Option';

const CustomPicker = configProps => pickerProps => (
    <BasePicker { ...configProps } { ...pickerProps } />
);

export const AreaPicker = CustomPicker({
    fetchAction: optionActions.getAreas,
    listState: 'areas',
    loadingState: 'areasLoading',
    nullPlaceholder: i18n.t('Seleccione una zona')
});

export const CampaignTypePicker = CustomPicker({
    fetchAction: optionActions.getCampaignTypes,
    listState: 'campaignTypes',
    loadingState: 'campaignTypesLoading',
    nullPlaceholder: i18n.t('Seleccione un tipo de campaña')
});

export const CityPicker = CustomPicker({
    fetchAction: optionActions.getCities,
    listState: 'cities',
    loadingState: 'citiesLoading',
    nullPlaceholder: i18n.t('Seleccione una ciudad')
});

export const CompanyPicker = CustomPicker({
    fetchAction: optionActions.getCompanies,
    listState: 'companies',
    loadingState: 'companiesLoading',
    nullPlaceholder: i18n.t('Seleccione una empresa')
});

export const ControlTypePicker = CustomPicker({
    fetchAction: optionActions.getControlTypes,
    listState: 'controlTypes',
    loadingState: 'controlTypesLoading',
    nullPlaceholder: i18n.t('Seleccione un tipo de control')
});

export const CostCenterPicker = CustomPicker({
    fetchAction: optionActions.getCostCenters,
    listState: 'costCenters',
    loadingState: 'costCentersLoading',
    nullPlaceholder: i18n.t('Seleccione un centro de costos')
});

export const CoveragePicker = CustomPicker({
    fetchAction: optionActions.getCoverages,
    listState: 'coverages',
    nullPlaceholder: i18n.t('Seleccione una cobertura')
});

export const DistrictPicker = CustomPicker({
    fetchAction: optionActions.getDistricts,
    listState: 'districts',
    loadingState: 'districtsLoading',
    nullPlaceholder: i18n.t('Seleccione un barrio')
});

export const EnrollmentTypePicker = CustomPicker({
    fetchAction: optionActions.getEnrollments,
    listState: 'enrollments',
    nullPlaceholder: i18n.t('Seleccione una matrícula')
});

export const NotificationTypePicker = CustomPicker({
    fetchAction: configActions.getConfigNotificationTypes,
    listState: 'notificationTypes',
    loadingState: 'notificationTypesLoading',
    reducer: 'config'
});

export const OfficePicker = CustomPicker({
    fetchAction: officeActions.getOfficeListing,
    listState: 'list',
    loadingState: 'loading',
    nullPlaceholder: i18n.t('Seleccione un consultorio'),
    reducer: 'office'
});

export const PatientPicker = CustomPicker({
    async: true,
    fetchAction: optionActions.getPatients,
    listState: 'patients',
    loadingState: 'patientsLoading',
    nullPlaceholder: i18n.t('Seleccione un paciente')
});

export const PlanPicker = CustomPicker({
    fetchAction: optionActions.getPlans,
    listState: 'plans',
    loadingState: 'plansLoading',
    nullPlaceholder: i18n.t('Seleccione un plan')
});

export const PolyOfficePicker = CustomPicker({
    fetchAction: optionActions.getPolyOffices,
    listState: 'polyOffices',
    nullPlaceholder: i18n.t('Seleccione un policonsultorio')
});

export const PositionPicker = CustomPicker({
    fetchAction: optionActions.getPositions,
    listState: 'positions',
    loadingState: 'positionsLoading',
    nullPlaceholder: i18n.t('Seleccione un cargo')
});

export const ProvincePicker = CustomPicker({
    fetchAction: optionActions.getProvinces,
    listState: 'provinces',
    loadingState: 'provincesLoading',
    nullPlaceholder: i18n.t('Seleccione una provincia')
});

export const RiskAgentPicker = CustomPicker({
    fetchAction: optionActions.getRiskAgents,
    listState: 'riskAgents',
    loadingState: 'riskAgentsLoading',
    nullPlaceholder: i18n.t('Seleccione un agente')
});

export const RiskAgentTypePicker = CustomPicker({
    fetchAction: optionActions.getRiskAgentTypes,
    listState: 'riskAgentTypes',
    loadingState: 'riskAgentTypesLoading',
    nullPlaceholder: i18n.t('Seleccione un tipo')
});

export const SpecialtyPicker = CustomPicker({
    fetchAction: optionActions.getSpecialties,
    listState: 'specialties',
    loadingState: 'specialtiesLoading',
    nullPlaceholder: i18n.t('Seleccione una especialidad')
});

export const VaccinePicker = CustomPicker({
    fetchAction: optionActions.getVaccines,
    listState: 'vaccines',
    loadingState: 'vaccinesLoading',
    nullPlaceholder: i18n.t('Seleccione una vacuna')
});

export const WorkplacePicker = CustomPicker({
    fetchAction: optionActions.getWorkplaces,
    listState: 'workplaces',
    loadingState: 'workplacesLoading',
    nullPlaceholder: i18n.t('Seleccione un lugar de trabajo')
});

export { default as AppointmentTypePicker } from './AppointmentTypePicker';
export { default as CampaignParticipantStatusPicker } from './CampaignParticipantStatusPicker';
export { default as DoctorPicker } from './DoctorPicker';
export { default as FrequencyPicker } from './FrequencyPicker';
export { default as GenderPicker } from './GenderPicker';
export { default as LanguagePicker } from './LanguagePicker';
export { default as LicenseReasonPicker } from './LicenseReasonPicker';
export { default as NotificationMeanPicker } from './NotificationMeanPicker';
export { default as QuizPicker } from './QuizPicker';
export { default as TurnTypePicker } from './TurnTypePicker';
export { default as VaccineDosePicker } from './VaccineDosePicker';
